import React from "react";
import "./recent.css";
import { useTranslation } from "react-i18next";

const Recent = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="recent">
        <div className="container">
          <section className="recent padding">
            <div className="container">
              <div className="heading">
                <h1>{t("recent_title")}</h1>
                <p>{t("recent_subtitle")}</p>
              </div>

              <div className="content grid3 mtop">
                {/* Service 1 */}
                <div className="box shadow">
                  <div className="img">
                    <img alt="" src="../images/cms.jpg" />
                  </div>
                  <div className="text">
                    <h4>{t("service1_title")}</h4>
                    <p className="form1">{t("service1_desc")}</p>
                  </div>
                  <div className="button flex">
                    <a href="/services">
                      <button className="buttonlang1">
                        <i className="fa fa-angle-right"></i> {t("read_more")}
                      </button>
                    </a>
                    <a href="/contact">
                      <button className="buttonlang1">
                        <i className="fa fa-phone"></i> {t("contact_us")}
                      </button>
                    </a>
                  </div>
                </div>

                {/* Service 2 */}
                <div className="box shadow">
                  <div className="img">
                    <img alt="" src="../images/cons.jpg" />
                  </div>
                  <div className="text">
                    <h4>{t("service2_title")}</h4>
                    <p className="form1">{t("service2_desc")}</p>
                  </div>
                  <div className="button flex">
                    <a href="/services">
                      <button className="buttonlang1">
                        <i className="fa fa-angle-right"></i> {t("read_more")}
                      </button>
                    </a>
                    <a href="/contact">
                      <button className="buttonlang1">
                        <i className="fa fa-phone"></i> {t("contact_us")}
                      </button>
                    </a>
                  </div>
                </div>

                {/* Service 3 */}
                <div className="box shadow">
                  <div className="img">
                    <img alt="" src="../images/safety.jpg" />
                  </div>
                  <div className="text">
                    <h4>{t("service3_title")}</h4>
                    <p className="form1">{t("service3_desc")}</p>
                  </div>
                  <div className="button flex">
                    <a href="/services">
                      <button className="buttonlang1">
                        <i className="fa fa-angle-right"></i> {t("read_more")}
                      </button>
                    </a>
                    <a href="/contact">
                      <button className="buttonlang1">
                        <i className="fa fa-phone"></i> {t("contact_us")}
                      </button>
                    </a>
                  </div>
                </div>

                {/* Service 4 */}
                <div className="box shadow">
                  <div className="img">
                    <img alt="" src="../images/childdress.jpg" />
                  </div>
                  <div className="text">
                    <h4>{t("service4_title")}</h4>
                    <p className="form1">{t("service4_desc")}</p>
                  </div>
                  <div className="button flex">
                    <a href="/services">
                      <button className="buttonlang1">
                        <i className="fa fa-angle-right"></i> {t("read_more")}
                      </button>
                    </a>
                    <a href="/contact">
                      <button className="buttonlang1">
                        <i className="fa fa-phone"></i> {t("contact_us")}
                      </button>
                    </a>
                  </div>
                </div>

                {/* Service 5 */}
                <div className="box shadow">
                  <div className="img">
                    <img alt="" src="../images/mendress.jpg" />
                  </div>
                  <div className="text">
                    <h4>{t("service5_title")}</h4>
                    <p className="form1">{t("service5_desc")}</p>
                  </div>
                  <div className="button flex">
                    <a href="/services">
                      <button className="buttonlang1">
                        <i className="fa fa-angle-right"></i> {t("read_more")}
                      </button>
                    </a>
                    <a href="/contact">
                      <button className="buttonlang1">
                        <i className="fa fa-phone"></i> {t("contact_us")}
                      </button>
                    </a>
                  </div>
                </div>

                {/* Service 6 */}
                <div className="box shadow">
                  <div className="img">
                    <img alt="" src="../images/beauty.jpg" />
                  </div>
                  <div className="text">
                    <h4>{t("service6_title")}</h4>
                    <p className="form1">{t("service6_desc")}</p>
                  </div>
                  <div className="button flex">
                    <a href="/services">
                      <button className="buttonlang1">
                        <i className="fa fa-angle-right"></i> {t("read_more")}
                      </button>
                    </a>
                    <a href="/contact">
                      <button className="buttonlang1">
                        <i className="fa fa-phone"></i> {t("contact_us")}
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </>
  );
};

export default Recent;
